import { render } from "./IconEyeHidden.vue?vue&type=template&id=270e8f4e"
import script from "./IconEyeHidden.vue?vue&type=script&lang=js"
export * from "./IconEyeHidden.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/tender_demo/www/spa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__